"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evemitter = void 0;
const evemitter = () => {
    let preventInfiniteEmit = false;
    let _handlerForAllEvents = null;
    const map = new Map();
    return {
        on: (key, handler) => {
            map.set(key, handler);
        },
        onAll: (handlerForAllEvents) => {
            _handlerForAllEvents = handlerForAllEvents;
        },
        emit: (key, value) => {
            if (preventInfiniteEmit)
                return;
            preventInfiniteEmit = true;
            const h = map.get(key);
            if (h) {
                h(value);
            }
            if (_handlerForAllEvents) {
                _handlerForAllEvents(key, value);
            }
            preventInfiniteEmit = false;
        },
    };
};
exports.evemitter = evemitter;
